@import '../styles/fonts.scss';
@import '../styles/palette.scss';
@import '../styles/deviceBreakpoints.scss';

h2 {
  @include merriweather(20);
}

.page {
  @include barlow(14);
  margin-bottom: 2.5rem;

  p:not(.fritekst) {
    max-width: 25rem;
  }

  .practiceplaceName {
    display: flex;
    align-items: center;
    margin: auto;
  }

  .generalInfo {
    .praksisPeriod {
      @include barlow(16);
      float: left;

      span {
        display: block;
      }

      .dateRange {
        font-weight: 600;

        @include target(mobile) {
          display: inline-block;
          padding-left: 0.3125rem;
        }
      }
    }

    .label {
      display: inline-block;
      margin-bottom: 0.75rem;
      margin-top: 0.75rem;
    }

    .onskelisteFrist {
      .date {
        background-color: white;
        display: inline;
        padding: 0.625rem 1.25rem 0.625rem 1.25rem;
      }
    }

    .emnebeskrivelse {
      margin-top: 2.25rem;

      @include target(mobile) {
        margin-top: 0.625rem;
      }

      svg {
        color: #079;
        vertical-align: -0.625rem;
      }

      .label {
        font-weight: 600;
      }

      .emne {
        float: right;

        @include target(mobile) {
          float: none;
        }
      }
    }
  }

  .profilePicture {
    height: 100%;
    max-width: 50rem;
    min-height: 28rem;
    overflow: hidden;
    position: relative;

    @include target(tablet) {
      min-height: 20rem;
    }

    img {
      left: 50%;
      min-height: 100%;
      width: 100%;
      object-fit: cover;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .profilePictureReplacement {
    background-color: _palette(profile-picture-bg);
    height: 100%;
    min-height: 20rem;
    padding-left: calc(50% - 1.25rem);
    padding-top: 8.5rem;
    position: relative;

    .iconWrapper {
      background-color: white;
      border-radius: 50%;
      height: 3rem;
      position: absolute;
      width: 3rem;

      svg {
        background-color: white;
        margin: 1em;
      }
    }
  }

  .praksisstedWrapper {
    background-color: _palette(card);
    border: 0.0625rem solid _palette(period-border-weak);
    border-radius: 5px;
    padding-top: 1.25rem;

    .headings {
      margin: 0.25em 0 0.25em 0;

      h4 {
        @include barlowMedium(14);
      }
      h5 {
        @include barlowMedium(12);
      }

      h5:last-child {
        display: flex;
        color: _palette(primary);

        &::before {
          display: inline-block;
          margin-right: 0.33em;
          transform: scaleX(-1);
          content: '↵';
        }
      }
    }

    .omPraksissted {
      padding-bottom: 0.375rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .srOnly {
      left: 0;
      max-height: 0.0625rem;
      max-width: 0.0625rem;
      position: absolute;
      top: 0;
      visibility: hidden;
    }

    .adresse {
      border-top: 0.0625rem solid _palette(period-border-weak);
      padding: 0.375rem 1rem;
    }

    .kommunikasjon {
      padding: 0.375rem 1rem;
    }
  }

  .praksisplassArea {
    background-color: white;
    min-height: 25rem;
    padding: 6.25rem 0.625rem 0.625rem;
    text-align: center;

    .imgWrapper {
      margin: auto;

      img {
        padding-left: 4rem;
      }
    }

    p {
      font-size: 1.125rem;
      margin: auto;
      max-width: 34.5rem;
      text-align: center;
    }

    .heading {
      color: _palette(secondary);
      font-size: 1.32rem;
      font-weight: 600;
      margin-bottom: 0.625rem;
      text-align: center;
    }

    button {
      margin-bottom: 1rem;
      margin-top: 1rem;
    }
  }

  .dashedSquareWithShadow {
    height: 6.25rem;
    margin: 0 auto 1.25rem;
    position: relative;
    width: 6.25rem;

    .shadow {
      border-radius: 10px;
      border: 2.5rem solid #f5f5f5;
      border-right-width: 3.125rem;
      border-left-width: 3.125rem;
      left: 3.125rem;
      position: absolute;
      top: 1.25rem;
      transform: skew(-50deg);
    }

    .dashedSquare {
      border: 0.625rem dashed #999;
      border-radius: 0.625rem;
      height: 6.25rem;
      margin: auto;
      position: absolute;
      width: 6.25rem;
    }
  }

  .changeWishListRow {
    & > div {
      margin: 0.625rem 0;
    }

    p {
      min-width: 100%;
    }

    .changeWishListButtonWrapper {
      text-align: right;
    }
  }
}
